import { Modal } from '@/components/ui/Modal';
import { Icon } from '@/components/ui/Icon';
import { useSessionReplaced } from '@/shared/stores/sessionReplaced';

function formatTime(iso?: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' });
}

/**
 * הודעה בולטת "מישהו אחר התחבר לחשבון שלך" — מעל כל מסך (גם מסך הכניסה
 * שאליו המשתמש נזרק). נשארת עד "הבנתי", גם אחרי רענון (sessionStorage).
 */
export function SessionReplacedNotice() {
  const by = useSessionReplaced((s) => s.replacedBy);
  const waitingForCall = useSessionReplaced((s) => s.waitingForCall);
  const dismiss = useSessionReplaced((s) => s.dismiss);
  if (!by) return null;

  const time = formatTime(by.at);
  const details = [by.label, time && `בשעה ${time}`, by.ip && `מכתובת ${by.ip}`].filter(Boolean).join(' · ');

  return (
    <Modal
      isOpen
      onClose={waitingForCall ? () => {} : dismiss}
      size="sm"
      zIndex={5000}
      footer={
        waitingForCall ? null : (
          <button type="button" className="btn primary" onClick={dismiss} style={{ minWidth: 120 }}>
            הבנתי
          </button>
        )
      }
    >
      <div role="alertdialog" aria-live="assertive" data-testid="session-replaced" style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, padding: '8px 4px' }}>
        <span style={{ width: 64, height: 64, borderRadius: 99, display: 'grid', placeItems: 'center', background: 'var(--danger-soft)', color: 'var(--danger)' }}>
          <Icon name="phoneMiss" size={30} />
        </span>
        <h2 style={{ margin: 0, fontSize: 'var(--t-xl, 22px)', fontWeight: 800, color: 'var(--danger)' }}>
          מישהו אחר התחבר לחשבון שלך
        </h2>
        <p style={{ margin: 0, fontSize: 'var(--t-md, 15px)', lineHeight: 1.6 }}>
          החשבון נפתח ממחשב או דפדפן אחר, ולכן {waitingForCall ? 'תנותק כאן' : 'נותקת כאן'} — גם מהמערכת וגם מהקו.
          אפשר לעבוד רק ממקום אחד בכל פעם.
        </p>
        {details && (
          <p style={{ margin: 0, fontSize: 'var(--t-sm, 13px)', color: 'var(--muted)' }}>
            התחברות חדשה: {details}
          </p>
        )}
        {waitingForCall ? (
          <p style={{ margin: 0, fontWeight: 700 }}>השיחה הנוכחית ממשיכה — הניתוק יקרה כשהיא תסתיים.</p>
        ) : (
          <p style={{ margin: 0, fontSize: 'var(--t-sm, 13px)' }}>
            אם זה לא אתה — התחבר מחדש ושנה את הסיסמה מיד.
          </p>
        )}
      </div>
    </Modal>
  );
}
